import React from 'react';

const levelStyles = {
  Foundational: { bg: '#fee2e2', text: '#dc2626' },
  Developing: { bg: '#fffaeb', text: '#e08e05' },
  Capable: { bg: '#e2f2ff', text: '#0071fe' },
  Advanced: { bg: '#d1fae5', text: '#2d6c4a' },
  'Best-in-class': { bg: '#ede9fe', text: '#3d35cd' },
};

const Badge = ({ level }) => {
  const style = levelStyles[level] || levelStyles['Capable'];

  return (
    <span
      className="inline-block text-xs font-semibold rounded px-2.5 py-1"
      style={{ backgroundColor: style.bg, color: style.text }}
    >
      {level}
    </span>
  );
};

export default Badge;
